<template>
    <seccion-datos :titulo="Datos"  @cambios="validarYGuardar($data)">
        <div class="row">
            <div class="col-md-6">
                <div class="form-group">
                    <label>{{ $t('general.nombre') }}</label>
                    <input type="text" class="form-control form-control-sm" placeholder="" v-model="nombre">
                </div>
            </div>
            <div class="col-md-6">
                <div class="form-group">
                    <label>Prefijo</label>
                    <input type="text" class="form-control form-control-sm" placeholder="" v-model="prefijo">
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-4">
                <div class="form-group">
                    <label>NIF</label>
                    <select v-model="tipo_identificacion" class="form-control form-control-sm">
                            <option value="">----</option>
                            <option value="N.I.F.">N.I.F.</option>
                            <option value="C.I.F.">C.I.F.</option>
                            <option value="N.I.E.">N.I.E.</option>
                            <option value="OTROS">{{ $t('general.otros') }}</option>
                    </select>
                </div>
            </div>
            <div class="col-md-4">
                <div class="form-group">
                    <label>Nº de Identificación</label>
                    <input type="text" class="form-control form-control-sm" placeholder="" v-model="cif">
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-9">
                <div class="form-group">
                    <label>{{ $t('general.direccion') }}</label>
                    <input type="text" class="form-control form-control-sm" placeholder="" v-model="domicilio">
                </div>
            </div>
            <div class="col-md-3">
                <div class="form-group">
                    <label>{{ $t('general.cpostal') }}</label>
                    <input type="text" class="form-control form-control-sm" placeholder="" v-model="cp">
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-6">
                <div class="form-group">
                    <label>{{ $t('general.poblacion') }}</label>
                    <input type="text" class="form-control form-control-sm" placeholder="" v-model="poblacion">
                </div>
            </div>
            <div class="col-md-6">
                <div class="form-group">
                    <label>{{ $t('general.provincia') }}</label>
                    <input type="text" class="form-control form-control-sm" placeholder="" v-model="provincia">
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-6">
                <div class="form-group">
                    <label>{{ $t('general.telefono') }}</label>
                    <input type="text" class="form-control form-control-sm" placeholder="" v-model="telefono">
                </div>
            </div>
            <div class="col-md-6">
                <div class="form-group">
                    <label>Fax</label>
                    <input type="text" class="form-control form-control-sm" placeholder="" v-model="fax">
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-12">
                <div class="form-group">
                    <label>Email</label>
                    <input type="text" class="form-control form-control-sm" placeholder="" v-model="email">
                </div>
            </div>
        </div>
    </seccion-datos>
</template>
<script>
export default {
    props: {
        esNueva:{
            type: Boolean
        },
        datos: {
            type: Object
        },
    },
    inject: ['guardar'],
    data() {
        return  {
            tipo_identificacion:'',
            nombre: '',
            prefijo: '',
            domicilio: null,
            cp: null,
            poblacion: null,
            provincia: null,
            telefono: null,
            fax: null,
            email: null,
            errores: [],
            cif: null,
            validarguardar:true,
        }
    },
    watch: {
        datos() {
            this.init();
        }
    },
    methods: {
        init() {
            if (this.datos) {
                for (let dato in this.$data) {
                    if (this.datos[dato] !== null && this.datos[dato] !== undefined) {
                        this[dato] = this.datos[dato];
                    }
                }
            }
            else {
                for (let dato in this.$data) {
                    this[dato] = null;
                }
            }
            this.datoscompania = this.$t('general.datoscompania');
           
        },
        async validarYGuardar(datos) {
            if(datos.cif){
                if(!datos.tipo_identificacion){
                    this.$toast.add({severity:'error', summary: 'Error', detail: 'Debe especificar un tipo de identificación', life: 5000});
                    return;
                }
            }
            try {
                this.$store.dispatch('cambiarGuardando', true);
                this.validarguardar = true;
                const datosEnviar = {...datos};
                delete datosEnviar.errores;
                this.validar(datosEnviar);
                if(this.validarguardar == true){
                    var resp = await this.guardar(datosEnviar)
                    console.log('resp', resp);
                    if(resp != false && this.esNueva){
                        for (let dato in this.$data) {
                            this[dato] = null;
                        }
                        // let rutaventana = '/companias/crear';
                        // let ruta = { fullPath: rutaventana,};
                        // this.$store.dispatch('quitarRuta', ruta);
                        // this.$emit('ventanaCerrar', ruta);
                        this.$router.push('/companias/' + resp.id);
                        // this.$router.push({ name: 'Compañías' });   
                    }
                }
                this.$store.dispatch('cambiarGuardando', false);
            } 
            catch (error) {
                this.$store.dispatch('cambiarGuardando', false);
                this.$toast.add({severity:'error', summary: 'Error', detail: error, life: 5000});
            }
        },
        validar(datos) {
            if (datos.nombre === null || datos.nombre.trim() === '') {
                this.validarguardar = false;
                                this.$toast.add({severity:'error', summary: 'Error', detail: 'Debe especificar un nombre', life: 5000});

                
            }
            if (datos.domicilio === null || datos.domicilio.trim() === '') { 
                                this.validarguardar = false;
                this.$toast.add({severity:'error', summary: 'Error', detail: 'Debe especificar un domicilio', life: 5000});

                

            }
            if (datos.poblacion === null || datos.poblacion.trim() === '') { 
                                this.validarguardar = false;
                this.$toast.add({severity:'error', summary: 'Error', detail: 'Debe especificar una población', life: 5000});

                

             }
            if (datos.provincia === null || datos.provincia.trim() === '') { 
                                this.validarguardar = false;
                this.$toast.add({severity:'error', summary: 'Error', detail: 'Debe especificar una provincia', life: 5000});

                

            }
            if (datos.cp === null || datos.cp.trim() === '') { 
                                this.validarguardar = false;
                this.$toast.add({severity:'error', summary: 'Error', detail: 'Debe especificar un código postal', life: 5000});

                

            }
           
            if (datos.cif === null || datos.cif.trim() === '') {
                                this.validarguardar = false;
                this.$toast.add({severity:'error', summary: 'Error', detail: 'Debe especificar un CIF', life: 5000});

                
            }
            
        }
    },
    created() {
        this.init();
    }
}
</script>